import src from "IMAGE";
export default { src, width: 143, height: 42, blurWidth: 0, blurHeight: 0};
